module.exports = __webpack_public_path__ + "img/fi-rr-camera.02f1b5b4.svg";